import React from "react";
import { CalendarDays, Users } from "lucide-react";
import CountdownTimer from "@/components/CountdownTimer";
import { NEXT_BATCH, SEATS_LEFT, BATCH_START_ISO } from "@/lib/courseData";

export const BatchInfo = ({ id }) => (
  <div className="space-y-3">
    <div className="flex flex-wrap items-center gap-3" data-testid={`${id}-batch-info`}>
      <div className="inline-flex items-center gap-2 px-3 py-2 rounded-sm border border-white/10 bg-white/5 text-sm text-white/90">
        <CalendarDays className="h-4 w-4 text-fin-green" />
        <span className="text-white/50">Next batch:</span>
        <span className="font-semibold" data-testid={`${id}-batch-date`}>{NEXT_BATCH}</span>
      </div>
      <div className="inline-flex items-center gap-2 px-3 py-2 rounded-sm border border-fin-green/40 bg-fin-green/10 text-sm text-fin-green font-semibold" data-testid={`${id}-seats-left`}>
        <Users className="h-4 w-4" />
        Only {SEATS_LEFT} seats left
      </div>
    </div>
    <div className="max-w-md">
      <CountdownTimer endsAt={BATCH_START_ISO} label="Batch starts in" testId={`${id}-batch-countdown`} />
    </div>
  </div>
);
